export const legacyCurrentFieldMarkingTypes = {
  official_signs: 'Офіційні знаки \\ Official signs',
  local_signs: 'Неофіційні знаки \\ Local signs',
  fenced: 'Огородження \\ Fenced',
  none: 'Відсутнє \\ None',
  other: 'Інше \\ Other',
};

export const currentFieldMarkingV2Types = {
  improvised: 'Імпровізоване \\ Improvised',
  temporary: 'Тимчасове \\ Temporary',
};

export const currentFieldMarkingTypes = {
  ...legacyCurrentFieldMarkingTypes,
  ...currentFieldMarkingV2Types,
};

export const CURRENT_FIELD_MARKING_LEGACY_OPTIONS = [
  { value: 'official_signs', label: 'Офіційні знаки \\ Official signs' },
  { value: 'local_signs', label: 'Неофіційні знаки \\ Local signs' },
  { value: 'fenced', label: 'Огородження \\ Fenced' },
  { value: 'none', label: 'Відсутнє \\ None' },
  { value: 'other', label: 'Інше \\ Other' },
];

export const CURRENT_FIELD_MARKING_V2_OPTIONS = [
  { value: 'improvised', label: 'Імпровізоване \\ Improvised' },
  { value: 'temporary', label: 'Тимчасове \\ Temporary' },
];
